import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { MenuModel } from '../model/menu.model';
import { MenuResponseModel } from '../model/api-suc';
import { EnvconfigService } from './envconfig.service';

@Injectable({
  providedIn: 'root'
})

export class MenuService {
  menuItems: MenuResponseModel;
  constructor(protected http: HttpClient,
    private router: Router,
    private environment: EnvconfigService) {
    this.menuItems = new MenuResponseModel;
  }

  getMenuSistemaIFI() {
    return this.menuItems;
  }
  getMenuSistema() {
    let _menu = localStorage.getItem(this.environment.get("LISTA_MENU"))!;
    let _lstMenu = JSON.parse(_menu) as MenuModel[];
    let _subMenu = localStorage.getItem(this.environment.get("LISTA_SUBMENU"))!;
    let _lstSubMenu = JSON.parse(_subMenu) as MenuModel[];

    this.menuItems.lstMenu = _lstMenu
    this.menuItems.lstSubMenu = _lstSubMenu;
    return this.menuItems;
  }
}